export default "__VITE_ASSET__DyapzyRy__"